import { FC, useCallback, useEffect, useState } from "react"
import { GooglePlace, GoogleReview, Reviews } from "../../../types"
import ImgGoogleLogo from "../../../assets/icons/google_logo.svg"
import ImgStar from "../../../assets/icons/star.svg"
import If from "../if"
import { useDispatch } from "react-redux"
import bbApi from "../../../api"
import { pushToast } from "../../../redux/slices/notifications"

interface Props {
  placeId: string
  reviews?: Reviews
  hideTitle?: boolean
}

const GoogleReviewList: FC<Props> = ({ placeId, reviews, hideTitle }) => {
  const dispatch = useDispatch()
  const [googlePlace, setGooglePlace] = useState<GooglePlace>()

  const setCurrentPlace = useCallback(
    async (placeId: string) => {
      try {
        const place = await bbApi.brand.getPlace({
          place_id: placeId
        })

        if ("status" in place) {
          dispatch(
            pushToast({
              msg: "Google place API is unavailble, try again later",
              timeout: 3000
            })
          )
        } else {
          setGooglePlace(place)
        }
      } catch (error) {
        console.error(error)
      }
    },
    [dispatch]
  )

  useEffect(() => {
    if (placeId) {
      setCurrentPlace(placeId)
    }
  }, [placeId, setCurrentPlace])

  return (
    <div className="pb-6">
      <If
        condition={!hideTitle}
        then={<div className="text-lg font-bold">Google reviews</div>}
      />
      <If
        condition={!!googlePlace}
        then={
          <div className="py-4 flex items-center">
            <div className="pr-3">
              <img src={ImgGoogleLogo} alt="Google Logo" />
            </div>
            <div>
              <div className="font-bold">{googlePlace?.name}</div>
              <div>{googlePlace?.formatted_address}</div>
            </div>
          </div>
        }
      />

      <If
        condition={!!reviews?.reviews?.length}
        then={reviews?.reviews.map((review, idx) => {
          const googleReview = review as GoogleReview
          return (
            <div key={idx} className="py-4">
              <div className="flex items-center">
                <img className="w-4 h-full" src={ImgStar} alt="Star" />

                <div className="font-bold pl-1">{googleReview.rating}</div>
                <div className="text-neutral-400 pl-2">
                  {googleReview.author_name}
                </div>
              </div>
              <div className="pt-4">{googleReview.text}</div>
            </div>
          )
        })}
        else={<div className="py-4">-</div>}
      />
    </div>
  )
}

export default GoogleReviewList
